import {BlackWhiteList} from "~/util/black-white-list";
export const EnabledAspectsBlackWhiteList = BlackWhiteList.fromConfig("ui.enabledAspects");
